<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_3744_8383)">
      <path d="M5 1V23H19V1H5ZM17 19H7V5H17V19Z" fill="#323232" />
    </g>
    <defs>
      <clipPath id="clip0_3744_8383">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
